import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  riskDeclaredLessThanRiskAssessed,
  riskDeclaredMoreThanRiskAssessed,
  riskDeclaredNotEqualRiskAssessed,
} from 'src/app/core/utilities/riskAssessment';
import { DetailedProductDescriptionComponent } from '../../../../core/components/detailed-product-description/detailed-product-description.component';
import { ResponseBase, ScreenModel,ResponseData, RequestData } from '../../../../core/models/common';
import {
  ProductDetailDescription,
  RiskComparedResult,
  RiskLevel,
} from '../../../../core/models/fna';
import { ApiService } from '../../../../core/services/api-mock.service';
import { GlobalsService } from '../../../../core/services/globals.service';
import { SideBarService } from '../../../../core/services/side-bar.service';
import { SharedAPIService } from '../../../../core/services/shared-api.service';

// What we receive from the API, and will send to the API.
export interface RiskProfileAssessmentData extends ResponseBase {
  DeclaredRiskProfile: string;
  AssessedRiskProfile: string;
  IsAcceptAssessedRiskProfile?: boolean;
  HasSelectedNonRecommendedProducts?: boolean;
}

export interface RiskProfileAssessmentSubmitData extends ResponseBase {
  IsAcceptAssessedRiskProfile?: boolean;
}

export class RiskProfileAssessmentModel extends ScreenModel {
  screenName = 'RiskProfileAssessment';
  pageID_read = 'R0070';
  pageID_write = 'S0070';
  pageID_productDetails = 'R0080';
  data: RiskProfileAssessmentData | undefined;
  declaredRiskProfile: string | undefined;
  assessedRiskProfile: string | undefined;
  isAcceptAssessedRiskProfile?: boolean;
  recommendedProductsDetailDescription?: ProductDetailDescription;
  hasSelectedNonRecommendedProducts?: boolean;
  jsonLoadResponse : RiskProfileAssessmentData | undefined
  assessmentMessage : string = ''
  productDetailResponse : any;
  sharedService:any;

  // Data lifecycle start.
  mapPegaObjToUI(data : any){
    console.log("FIRSTEVER MAPPING TEST +++++++")
    console.log(data)
    this.productDetailResponse = this.sharedService.retrieveProductDetails();
    let tableADescList =  this.sharedService.createTableAData(this.productDetailResponse.ProductDetails.TableA)
    let tableBDescList =  this.sharedService.createTableAData(this.productDetailResponse.ProductDetails.TableB)
    this.sharedService.setTableABDesc({
      tableA:tableADescList,
      tableB:tableBDescList
    })    
    let riskandObjectiveDetails = data['RiskandObjectiveDetails']
    this.sharedService.setAssessedRiskProfile(riskandObjectiveDetails['AssessedRiskProfile'])
    this.assessmentMessage = riskandObjectiveDetails['RiskProfileComparisonMessage']
     let riskProfileAssessmentData:RiskProfileAssessmentData  = {
      DeclaredRiskProfile: riskandObjectiveDetails['DeclaredRiskProfile'],
      AssessedRiskProfile: riskandObjectiveDetails['AssessedRiskProfile'],
      IsAcceptAssessedRiskProfile: riskandObjectiveDetails['ReConsiderDeclaredRiskProfile']=='Yes'?true:(riskandObjectiveDetails['ReConsiderDeclaredRiskProfile']=='No'?false:undefined),
      HasSelectedNonRecommendedProducts: false,
     }
     return riskProfileAssessmentData;
   }

  deriveFromData(data: RiskProfileAssessmentData) {
    console.log('deriveFromData, model:', this);
   
    this.declaredRiskProfile = data.DeclaredRiskProfile;
    this.assessedRiskProfile = data.AssessedRiskProfile;
    this.isAcceptAssessedRiskProfile = data.IsAcceptAssessedRiskProfile;
    this.recommendedProductsDetailDescription =
    this.globals.model.recommendedProductsDetailDescription;
    this.hasSelectedNonRecommendedProducts =
      data.HasSelectedNonRecommendedProducts;
  }

 
  deriveDataFromModel(): RequestData {
    // @For integration
    if (
      this.isAcceptAssessedRiskProfile == null &&
      this.assessedRiskProfile != this.declaredRiskProfile
    ) {
      throw new Error(
        '[Should not reach here] Form validation should handle null states',
      );
    }
    // return {
    //   IsAcceptAssessedRiskProfile: this.isAcceptAssessedRiskProfile,
    // };

    this.sharedService.setAcceptAssessedRiskProfile(this.isAcceptAssessedRiskProfile )
    return {
      ServiceBody :{
        RiskandObjectiveDetails: {
          ReConsiderDeclaredRiskProfile: this.isAcceptAssessedRiskProfile?'Yes':'No'
       }

      }// this.isQualifiedAccreditedInvestor}
    };
  }

  syncModelWithForm() {
    console.log('[RiskProfileAssessmentModel] syncModelWithForm');
    const formValues = this.form?.value;
    this.isAcceptAssessedRiskProfile = formValues.isAcceptAssessedRiskProfile;

    if (this.globals.simulateServerBehaviour) {
      this.globals.mockIsAcceptAssessedRiskProfile =
        formValues.isAcceptAssessedRiskProfile;
      this.globals.mockIsAcceptRecommendedProducts = null;
      this.globals.mockIsPurchaseTableBProducts = null;
    }
  }

  validate() {
    if (!this.isSubmitted) {
      return;
    }

    if (!this.form) {
      return;
    }

    this.isValid = this.form.valid;
  }
}

@Component({
  selector: 'app-risk-profile-assessment',
  templateUrl: './risk-profile-assessment.component.html',
  styleUrls: ['./risk-profile-assessment.component.scss'],
})
export class RiskProfileAssessmentComponent implements OnInit {
  model = new RiskProfileAssessmentModel(
    this.globals,
    this.apiService,
    this.el,
  );

  form: FormGroup = this.formBuilder.group({
    isAcceptAssessedRiskProfile: [undefined],
  });

  @ViewChild('confirmationModal')
  confirmationModal: ElementRef | undefined;

  hasClearedPreviouslySelectedProducts: boolean = false;

  constructor(
    private router: Router,
    public globals: GlobalsService,
    protected apiService: ApiService,
    private formBuilder: FormBuilder,
    private el: ElementRef,
    private sideBarService: SideBarService,
    private modalService: NgbModal,
    private sharedAPIService : SharedAPIService
  ) {
    this.model.form = this.form;
    this.model.initializeForm = this.initializeForm;
    this.model.goToNextScreen = this.goToNextScreen;
    this.model.goToPreviousScreen = this.goToPreviousScreen;
    this.model.sharedService = this.sharedAPIService
  }

  async ngOnInit() {
     this.model.productDetailResponse = await this.model.callMiscService(this.model.pageID_productDetails,{})
     this.sharedAPIService.storeProductDetailsToSS(this.model.productDetailResponse)
    await this.model.loadData();

    this.formControlValueChanged();
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload($event: any) {
    $event.returnValue =
      'Changes to your data will be lost! Are you sure you want to exit?';
  }

  initializeForm = () => {
    if (this.model.isAcceptAssessedRiskProfile !== null) {
      this.isAcceptAssessedRiskProfileControl.setValue(
        this.model.isAcceptAssessedRiskProfile,
      );
    }

    if (this.declaredNotEqualAssessed) {
      this.isAcceptAssessedRiskProfileControl.setValidators([
        Validators.required,
      ]);
    } else {
      this.isAcceptAssessedRiskProfileControl.clearValidators();
    }

    this.isAcceptAssessedRiskProfileControl.updateValueAndValidity();
  };

  goToNextScreen = async () => {
    console.log('[RiskAssessmentProfileComponent] goToNextScreen');
    if (
      this.declaredMoreThanAssessed &&
      !this.isAcceptAssessedRiskProfileControl.value
    ) {
      await this.router.navigateByUrl('/fna/non-recommended-products');
      return;
    }

    await this.router.navigateByUrl('/fna/recommended-products');
  };

  goToPreviousScreen = async () => {
    console.log('[RiskAssessmentProfileComponent] goToNextScreen');
    await this.router.navigateByUrl('/fna/risk-and-objectives');
  };

  formControlValueChanged() {
    this.isAcceptAssessedRiskProfileControl.valueChanges.subscribe((value) => {
      this.updateSideBarStepper();
    });
  }

  isAcceptAssessRiskProfileOptionClick(event: any, radioValue: boolean) {
    if (
      this.model.hasSelectedNonRecommendedProducts === true &&
      !this.hasClearedPreviouslySelectedProducts &&
      this.model.isAcceptAssessedRiskProfile !== null
    ) {
      event.preventDefault();
      event.stopPropagation();
      this.modalService
        .open(this.confirmationModal, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            console.log('Confirmation modal result: ', result);
            if (result == 'save') {
              console.log('event.target.value: ', event);

              //TODO please actually call backend to clear data
              // This is just a flag
              this.hasClearedPreviouslySelectedProducts = true;

              this.isAcceptAssessedRiskProfileControl.setValue(radioValue);
            }
          },
          (reason) => {},
        );
    }
  }

  updateSideBarStepper() {
    if (this.declaredMoreThanAssessed) {
      this.sideBarService.showNonRecommendedProduct =
        !this.isAcceptAssessedRiskProfileControl.value;
      this.sideBarService.showRecommendedProduct =
        this.isAcceptAssessedRiskProfileControl.value;
    } else if (this.declaredLessThanAssessed) {
      this.sideBarService.showNonRecommendedProduct = false;
      this.sideBarService.showRecommendedProduct = true;
    } else {
      this.sideBarService.showNonRecommendedProduct = false;
      this.sideBarService.showRecommendedProduct = true;
    }
  }

  showRecommendedProduct() {
    const modalRef = this.modalService.open(
      DetailedProductDescriptionComponent,
      {
        modalDialogClass: 'fna-modal-dialog modal-fixed-height',
        scrollable: true,
      },
    );
    modalRef.componentInstance.title = 'Table A: Recommended products';
    console.log(
      'this.model.assessedRiskProfile',
      this.model.assessedRiskProfile,
    );
    if (this.model.assessedRiskProfile === RiskLevel.CONSERVATIVE) {
      modalRef.componentInstance.lowRiskContent =
        this.model.recommendedProductsDetailDescription?.lowRiskDescription;
    } else if (this.model.assessedRiskProfile === RiskLevel.MODERATE) {
      modalRef.componentInstance.lowRiskContent =
        this.model.recommendedProductsDetailDescription?.lowRiskDescription;
      modalRef.componentInstance.moderateRiskContent =
        this.model.recommendedProductsDetailDescription?.moderateRiskDescription;
    } else if (this.model.assessedRiskProfile === RiskLevel.AGGRESSIVE) {
      modalRef.componentInstance.lowRiskContent =
        this.model.recommendedProductsDetailDescription?.lowRiskDescription;
      modalRef.componentInstance.moderateRiskContent =
        this.model.recommendedProductsDetailDescription?.moderateRiskDescription;
      modalRef.componentInstance.highRiskContent =
        this.model.recommendedProductsDetailDescription?.highRiskDescription;
    }
  }

  //region: getters
  get isAcceptAssessedRiskProfileControl(): FormControl {
    return this.form.get('isAcceptAssessedRiskProfile') as FormControl;
  }

  get declaredNotEqualAssessed(): boolean {
    return riskDeclaredNotEqualRiskAssessed(
      this.model.declaredRiskProfile,
      this.model.assessedRiskProfile,
    );
  }

  get declaredMoreThanAssessed(): boolean {
    return riskDeclaredMoreThanRiskAssessed(
      this.model.declaredRiskProfile,
      this.model.assessedRiskProfile,
    );
  }

  get declaredLessThanAssessed(): boolean {
    return riskDeclaredLessThanRiskAssessed(
      this.model.declaredRiskProfile,
      this.model.assessedRiskProfile,
    );
  }

  //endregion
}
